module.exports = __webpack_public_path__ + "img/message-sent-5.3d3ba11f.png";